import { Signal } from "signals";
import { IIntegrationWrapper, IWrapperMediator } from "slotworks/integration/revolver/wrapper/wrapper-mediator";
import { InitRecordSchema } from "slotworks/integration/revolver/schema/init-record-schema";
import { SpinResponseSchema } from "slotworks/integration/revolver/schema/spin-record-schema";
import { WrapperEvent } from "slotworks/integration/revolver/wrapper/WrapperEvent";
import gameState from "slotworks/model/game-state";
import { StopAutoplayCommand } from "slotworks/commands/autoplay/stop-autoplay";

enum REQUEST_TYPES {
    INIT = "ucip.basic.g2wInitializationRequest",
    BALANCE_UPDATE = "ucip.balanceupdate.g2wBalanceUpdateNotification",
    AUTOPLAY_START = "ucip.autoplay.g2wAutoplayStartNotification",
    AUTOPLAY_END = "ucip.autoplay.g2wAutoplayEndNotification"
}

const INIT_REQUEST = {
    _type: REQUEST_TYPES.INIT,
    version: "1.0.0",
    features: ["pause", "autoplay", "balanceupdate"]
}

export class PlaytechWrapper implements IIntegrationWrapper, IWrapperMediator {
    public events = new Signal();

    public constructor() {
        const w2gMappings: { [key: string]: (json: any) => void } = {
            "ucip.basic.w2gInitializationResponse": this.initializeResponseHandler,
            "ucip.autoplay.w2gInterruptGameplayCommand": this.interruptGameplayHandler,
            "ucip.pause.w2gPauseCommand": this.gamePauseHandler,
            "ucip.displaystatus.w2gVisibilityChangeNotification": this.visibilityChangeHandler,
            "ucip.sound.w2gSoundUpdateNotification": this.soundUpdateHandler,
            "ucip.balancerefresh.w2gRefreshBalanceCommand": this.refreshBalanceHandler,
            "ucip.closegame.w2gCloseGameRequest": this.closeGameHandler
        }

        window.onmessage = function (e: any) {
            if(e && e.data) {
                try {
                    let jsonObj = JSON.parse(e.data);
                    let type = jsonObj._type as string;
                    (w2gMappings[type] != null) ? w2gMappings[type](jsonObj) : console.log("[GAME ERROR]: Undefined request");
                } catch(e) {}
            }
        };

        this.sendPostMessage(INIT_REQUEST);
    }

    public roundStarted = (spinId: number, balanceBeforeSpin?: number) => {
        this.sendBalanceUpdate(gameState.getCurrentGame().balance);
    }

    public roundEnd = (win: number, bet: number, balance: number) => {
        this.sendBalanceUpdate(balance);
    }

    public autoplayStart = () => {
        const autoplayStartRequest = {
            _type: REQUEST_TYPES.AUTOPLAY_START
        }
        this.sendPostMessage(autoplayStartRequest);
    };
    public autoplayEnd = () => {
        const autoplayEndRequest = {
            _type: REQUEST_TYPES.AUTOPLAY_END
        }
        this.sendPostMessage(autoplayEndRequest);
    };

    private sendPostMessage(request: any) {
        let requestString = JSON.stringify(request);
        window.top.postMessage(requestString, "*");
    }

    private sendBalanceUpdate(balance: number) {
        const update = {
            _type: REQUEST_TYPES.BALANCE_UPDATE,
            balance: {
                value: balance,
            }
        }
        this.sendPostMessage(update);
    }

    private initializeResponseHandler = (json: any) => { }

    private gamePauseHandler = (json: any) => {
        if (json.pause === true) {
            this.events.dispatch(WrapperEvent.Pause, { waitForSpinFinish: true });
        } else if (json.pause === false) {
            this.events.dispatch(WrapperEvent.Resume);
        }
    }

    private interruptGameplayHandler = (json: any = null) => {
        StopAutoplayCommand();
    }

    private soundUpdateHandler = (json: any) => {

    }

    private refreshBalanceHandler = (json: any = null) => {
        this.sendBalanceUpdate(gameState.getCurrentGame().balance);
    }

    private closeGameHandler = (json: any) => {

    }

    private visibilityChangeHandler = (json: any) => {

    }

    public balanceUpdated = (balance: number) => { }

    public gameDataLoaded = (response: InitRecordSchema) => { }

    public gameLoaded = () => { }

    public init = () => { }

    public quit = () => { }

    public roundStart = (totalBet: number, balance: number) => { }

    public spinResponseReceived = (response: SpinResponseSchema) => { }
    public reportPaused = () => { }


    public dispose = () => {
        this.events.removeAll();
        this.events = null;
    }
}




// WEBPACK FOOTER //
// ./~/slotworks/integration/playtech/PlaytechWrapper.ts